import React from 'react';
import './ConfirmationModal.css'; // Import the updated CSS file

const ConfirmationModal = ({ show, onConfirm, onCancel, message }) => {
  if (!show) return null;

  return (
    <div className="statusmodal-overlay">
      <div className="statusmodal-content">
        <p style={{fontWeight:"500"}}>{message}</p>
        <div className="statusmodal-actions">
          <button onClick={onConfirm} className="statusmodal-btn">OK</button>
          <button onClick={onCancel} className="statusmodal-btn statusmodal-cancel-btn">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
